document.documentElement.classList.remove('no-js');
document.documentElement.classList.add('reveal-ready');

document.addEventListener('DOMContentLoaded', () => {
  const toggle = document.querySelector('[data-menu-toggle]');
  const nav = document.querySelector('[data-mobile-nav]');

  if (toggle && nav) {
    toggle.addEventListener('click', () => {
      const open = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', String(!open));
      nav.hidden = open;
    });
  }

  document.querySelectorAll('[data-product-thumb]').forEach((button) => {
    button.addEventListener('click', () => {
      const gallery = button.closest('.pdp-gallery');
      const main = gallery?.querySelector('[data-product-main]');
      if (main) {
        main.src = button.dataset.image;
        main.srcset = '';
      }
      gallery?.querySelectorAll('[data-product-thumb]').forEach((thumb) => thumb.removeAttribute('aria-current'));
      button.setAttribute('aria-current', 'true');
    });
  });

  document.querySelectorAll('[data-variant-select]').forEach((select) => {
    select.addEventListener('change', () => {
      const productInfo = select.closest('.pdp-info');
      const product = productInfo?.closest('.pdp');
      const option = select.options[select.selectedIndex];
      const price = productInfo?.querySelector('[data-variant-price]');
      const availability = productInfo?.querySelector('[data-variant-availability]');
      const addButton = productInfo?.querySelector('[data-add-to-cart]');
      const mainImage = product?.querySelector('[data-product-main]');
      const isAvailable = option?.dataset.available === 'true';
      const inventory = Number(option?.dataset.inventory || 0);
      const stickyPrice = document.querySelector('[data-sticky-price]');
      const stickySubmit = document.querySelector('[data-sticky-submit]');

      if (price && option?.dataset.price) price.textContent = option.dataset.price;
      if (stickyPrice && option?.dataset.price) stickyPrice.textContent = option.dataset.price;
      if (availability) {
        availability.textContent = isAvailable ? (inventory > 0 && inventory <= 10 ? `${inventory} in stock` : 'In stock and ready to order') : 'Currently unavailable';
        availability.classList.toggle('is-unavailable', !isAvailable);
      }
      if (addButton) {
        addButton.disabled = !isAvailable;
        addButton.textContent = isAvailable ? 'Add to cart' : 'Currently unavailable';
      }
      if (stickySubmit) {
        stickySubmit.disabled = !isAvailable;
        stickySubmit.textContent = isAvailable ? 'Add to cart' : 'Unavailable';
      }
      if (mainImage && option?.dataset.image) {
        mainImage.src = option.dataset.image;
        mainImage.srcset = '';
      }
    });
  });

  document.querySelectorAll('.quantity-stepper').forEach((stepper) => {
    const input = stepper.querySelector('[data-quantity-input]');
    const decrease = stepper.querySelector('[data-quantity-minus]');
    const increase = stepper.querySelector('[data-quantity-plus]');
    if (!input) return;

    decrease?.addEventListener('click', () => {
      input.value = String(Math.max(Number(input.min || 1), Number(input.value || 1) - 1));
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
    increase?.addEventListener('click', () => {
      const max = input.max ? Number(input.max) : Infinity;
      input.value = String(Math.min(max, Number(input.value || 1) + 1));
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  });

  document.querySelectorAll('[data-slider]').forEach((slider) => {
    const track = slider.querySelector('[data-slider-track]');
    const previous = slider.querySelector('[data-slider-prev]');
    const next = slider.querySelector('[data-slider-next]');
    if (!track) return;
    const move = (direction) => track.scrollBy({ left: direction * Math.max(track.clientWidth * .78, 280), behavior: 'smooth' });
    previous?.addEventListener('click', () => move(-1));
    next?.addEventListener('click', () => move(1));
  });

  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  document.querySelectorAll('[data-consultation]').forEach((consultation) => {
    const panels = Array.from(consultation.querySelectorAll('[data-consultation-panel]'));
    const next = consultation.querySelector('[data-consultation-next]');
    const back = consultation.querySelector('[data-consultation-back]');
    const restart = consultation.querySelector('[data-consultation-restart]');
    const results = consultation.querySelector('[data-consultation-results]');
    const resultSets = Array.from(consultation.querySelectorAll('[data-consultation-result]'));
    const progress = consultation.querySelector('[data-consultation-progress]');
    const stepLabel = consultation.querySelector('[data-consultation-step]');
    const message = consultation.querySelector('[data-consultation-message]');
    const resultTitle = consultation.querySelector('[data-consultation-result-title]');
    const resultText = consultation.querySelector('[data-consultation-result-text]');
    const summary = consultation.querySelector('[data-consultation-summary]');
    let current = 0;

    const selectedValue = (name) => consultation.querySelector(`input[name="${name}"]:checked`)?.value || '';
    const update = () => {
      panels.forEach((panel, index) => { panel.hidden = index !== current; });
      if (progress) progress.style.width = `${((current + 1) / panels.length) * 100}%`;
      if (stepLabel) stepLabel.textContent = String(current + 1);
      if (back) back.hidden = current === 0;
      if (next) next.textContent = current === panels.length - 1 ? 'See my recommendation' : 'Continue';
      if (message) message.textContent = '';
    };

    const showResults = (savedAnswers = null) => {
      const answers = savedAnswers || {
        concern: selectedValue('consultation_concern'),
        feel: selectedValue('consultation_feel'),
        reactivity: selectedValue('consultation_reactivity'),
        goal: selectedValue('consultation_goal')
      };
      const concern = answers.concern;
      const selectedSet = resultSets.find((set) => set.dataset.consultationResult === concern) || resultSets[0];
      resultSets.forEach((set) => { set.hidden = set !== selectedSet; });
      if (resultTitle) resultTitle.textContent = selectedSet?.dataset.resultTitle || 'Your focused routine';
      if (resultText) resultText.textContent = selectedSet?.dataset.resultText || 'These formulas are a thoughtful place to begin.';
      if (summary) {
        summary.value = `Concern: ${concern}; after cleansing: ${answers.feel}; reactivity: ${answers.reactivity}; goal: ${answers.goal}`;
      }
      try { sessionStorage.setItem('earthenConsultationAnswers', JSON.stringify(answers)); } catch (error) { /* storage is optional */ }
      consultation.querySelector('.consultation-quiz')?.setAttribute('hidden', '');
      if (results) results.hidden = false;
      results?.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
    };

    next?.addEventListener('click', () => {
      const checked = panels[current]?.querySelector('input[type="radio"]:checked');
      if (!checked) {
        if (message) message.textContent = 'Choose one answer to continue.';
        panels[current]?.querySelector('input[type="radio"]')?.focus();
        return;
      }
      if (current < panels.length - 1) {
        current += 1;
        update();
        panels[current]?.querySelector('legend')?.focus?.();
      } else {
        showResults();
      }
    });
    back?.addEventListener('click', () => { if (current > 0) { current -= 1; update(); } });
    restart?.addEventListener('click', () => {
      consultation.querySelectorAll('input[type="radio"]').forEach((input) => { input.checked = false; });
      current = 0;
      if (results) results.hidden = true;
      consultation.querySelector('.consultation-quiz')?.removeAttribute('hidden');
      update();
      consultation.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
    });
    update();
    const serverResponse = consultation.querySelector('.consultation-followup .form-success, .consultation-followup .errors');
    if (serverResponse) {
      try {
        const savedAnswers = JSON.parse(sessionStorage.getItem('earthenConsultationAnswers') || 'null');
        if (savedAnswers?.concern) showResults(savedAnswers);
      } catch (error) { /* keep the quiz available if storage is unavailable */ }
    }
  });

  const revealItems = document.querySelectorAll('.reveal-section');
  if (!reduceMotion && 'IntersectionObserver' in window) {
    const revealObserver = new IntersectionObserver((entries, observer) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-revealed');
        entry.target.querySelectorAll('[data-count-to]').forEach((counter) => {
          const target = Number(counter.dataset.countTo || counter.textContent || 0);
          const started = performance.now();
          const tick = (now) => {
            const progress = Math.min((now - started) / 850, 1);
            counter.textContent = String(Math.round(target * (1 - Math.pow(1 - progress, 3))));
            if (progress < 1) requestAnimationFrame(tick);
          };
          requestAnimationFrame(tick);
        });
        observer.unobserve(entry.target);
      });
    }, { threshold: .14 });
    revealItems.forEach((item) => revealObserver.observe(item));
  } else {
    revealItems.forEach((item) => item.classList.add('is-revealed'));
  }

  const stickyAtc = document.querySelector('[data-sticky-atc]');
  const mainAtc = document.querySelector('[data-add-to-cart]');
  if (stickyAtc && mainAtc && 'IntersectionObserver' in window) {
    const stickyObserver = new IntersectionObserver(([entry]) => {
      const show = !entry.isIntersecting && window.scrollY > mainAtc.getBoundingClientRect().top + window.scrollY;
      stickyAtc.classList.toggle('is-visible', show);
      stickyAtc.setAttribute('aria-hidden', String(!show));
    });
    stickyObserver.observe(mainAtc);
  }
});

document.addEventListener('change', (event) => {
 const select=event.target.closest('[data-quick-variant]');
 if(select) {
  const form=select.closest('form'), option=select.selectedOptions[0], available=option.dataset.available==='true';
  form.querySelectorAll('button[type="submit"]').forEach(button=>button.disabled=!available);
  form.querySelector('[data-quick-add]').textContent=available?'Add to cart':'Sold out';
  const card=form.closest('.product-card,.routine-card');
  const price=card?.querySelector('.product-card__price,.routine-card__offer strong');
  if(price) price.textContent=option.dataset.price;
 }
 if(event.target.matches('[data-variant-select]')) {
  const form=event.target.closest('form');
  const buy=form?.querySelector('[data-pdp-buy]');
  if(buy) buy.disabled=event.target.selectedOptions[0].dataset.available!=='true';
 }
});